import { EChartsOption } from 'echarts';
import { dataViewFormatter, getTimestampedFileNameForWidget } from '../helpers/widgets';

interface RoseChartData {
  textValue: string;
  count: number;
  rank: number;
}

/**
 * Should be 5 colours max, but just in case an extra 3
 * selected by rank attribute
 */
const MauriColours: string[] = [
  '#00b1d8', // Mauri Ora - Active Mauri
  '#8c7ebb', // Mauri Tu - Resilient Mauri
  '#f26b4b', // Mauri Oho - Awakened Mauri
  '#66c39b', // Mauri Moe - Dormant Mauri
  '#ee4891', // Mauri Rere - Unstable Mauri
  '#fbcaaa',
  '#007093',
  '#00916f',
];

const getRoseChartConfig = (data: RoseChartData[]): EChartsOption => {
  if (data === undefined) {
    const cfg: EChartsOption = {};
    return cfg;
  }

  const radius = [0, 100];

  const cfg: EChartsOption = {
    color: data.map((item: RoseChartData) => MauriColours[item.rank] || MauriColours[7]),
    tooltip: {
      trigger: 'item',
      formatter: (params: any) => {
        return params.name;
      },
    },
    toolbox: {
      show: true,
      feature: {
        mark: { show: true },
        dataView: {
          show: true,
          readOnly: true,
          optionToContent: (option: any): string | HTMLElement => dataViewFormatter(option as EChartsOption),
        },
        saveAsImage: {
          show: true,
          name: getTimestampedFileNameForWidget('rongo-mauri-chart'),
        },
      },
    },
    series: [
      {
        name: 'Radius Mode',
        type: 'pie',
        center: ['50%', '50%'],
        radius: [0, '80%'],
        roseType: 'area',
        itemStyle: {
          borderWidth: 10,
          borderColor: '#f5f5f5', // very light gray
          color: '#fff',
        },
        emphasis: {
          disabled: true,
        },
        z: 0,
        data: [{ value: 10 }],
      },
      {
        name: '',
        type: 'pie',
        center: ['50%', '50%'],
        radius,
        roseType: 'area',
        itemStyle: {
          borderRadius: 8,
        },
        label: {
          overflow: 'break',
        },
        data: data.map((item: RoseChartData) => ({
          value: item.count,
          name: item.textValue,
        })),
      },
    ],
  };
  return cfg;
};

export { getRoseChartConfig, MauriColours, RoseChartData };
